import Vue from 'vue'
import VueRouter from 'vue-router'
import TokiaLanding from '../components/TokiaLanding.vue'
import RegistrarUsuario from '../../src/components/RegistrarUsuario.vue'
import RegisterSuccess from '../../src/components/RegisterSuccess.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Landing',
    component: TokiaLanding
  },
  {
    path: '/RegistrarUsuario',
    name: 'RegistrarUsuario',
    component: RegistrarUsuario
  },
  {
    path: '/RegistroExitoso',
    name: 'RegistroExitoso',
    component: RegisterSuccess
  },
  {
    path: '*', redirect: '/'
  }
  
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
